class APIError extends Error {
    constructor(message, status, data) {
      super(message);
      this.name = "APIError";
      this.status = status;
      this.data = data;
    }
  }

export default APIError